.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  min-height: var(--control-md);
}

.disabled {
  opacity: 0.55;
}

.text {
  display: flex;
  flex-direction: column;
  gap: var(--space-0-5);
  min-width: 0;
  cursor: pointer;
}

.label {
  font-size: var(--text-md);
}

.description {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
  line-height: var(--leading-snug);
}

.switch {
  position: relative;
  flex: none;
  width: 44px;
  height: 26px;
  padding: 0;
  border: none;
  border-radius: var(--radius-full);
  background: var(--color-border-strong);
  cursor: pointer;
  transition: background-color var(--duration-base) var(--ease-standard);
}

.switch[data-state="checked"] {
  background: var(--color-accent);
}

.switch:disabled {
  cursor: not-allowed;
}

.thumb {
  display: block;
  width: 20px;
  height: 20px;
  border-radius: var(--radius-full);
  background: var(--color-on-accent);
  box-shadow: var(--shadow-sm);
  transform: translateX(3px);
  transition: transform var(--duration-base) var(--ease-standard);
}

.thumb[data-state="checked"] {
  transform: translateX(21px);
}
